module.exports = __webpack_public_path__ + "img/bufu-logo-trans.2d370c60.png";